var _style, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScala(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -223.0867,
    y1: 275.3394,
    x2: -222.9673,
    y2: 275.3394,
    gradientTransform: "matrix(256 0 0 96 57120 -26400)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F4F4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,30.7v3.8c0,0.6,13.9,1.7,22.9,3.8l0,0c4.4-1,7.6-2.3,7.6-3.8l0,0v-3.8c0-1.6-3.2-2.8-7.6-3.8l0,0 C23.7,28.9,9.8,30,9.8,30.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -223.0867,
    y1: 276.5135,
    x2: -222.9673,
    y2: 276.5135,
    gradientTransform: "matrix(256 0 0 96 57120 -26528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F4F4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.8,15.4v3.8c0,0.6,13.9,1.7,22.9,3.8l0,0c4.4-1,7.6-2.3,7.6-3.8l0,0v-3.8c0-1.6-3.2-2.8-7.6-3.8l0,0 C23.7,13.7,9.8,14.7,9.8,15.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -223.0867,
    y1: 275.7559,
    x2: -222.9673,
    y2: 275.7559,
    gradientTransform: "matrix(256 0 0 160 57120 -44096)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C40000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.8,23v11.5c0-1,30.6-2.9,30.6-7.6l0,0V15.4C40.4,20.2,9.8,22.1,9.8,23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -223.0867,
    y1: 276.4603,
    x2: -222.9673,
    y2: 276.4603,
    gradientTransform: "matrix(256 0 0 160 57120 -44224)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C40000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0000"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.8,7.7v11.5c0-1,30.6-2.9,30.6-7.6l0,0V0.1C40.4,4.9,9.8,6.8,9.8,7.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -223.0867,
    y1: 275.0514,
    x2: -222.9673,
    y2: 275.0514,
    gradientTransform: "matrix(256 0 0 160 57120 -43968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C40000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0000"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.8,38.3v11.5c0-1,30.6-2.9,30.6-7.6l0,0V30.7C40.4,35.4,9.8,37.4,9.8,38.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScala);
export default __webpack_public_path__ + "static/media/scala.b8a9dbeb7ba6d9414709d9f8bb35c1d1.svg";
export { ForwardRef as ReactComponent };